/** @param {HTMLButtonElement} loadMoreButton */
const initButton = (loadMoreButton) => {
    if (loadMoreButton.dataset.blogInitialized) {
        return;
    }

    const root = loadMoreButton.closest('.shopify-section') ?? document;
    const blogPostsContainer = root.querySelector('[data-blog-posts]');
    if (!blogPostsContainer) {
        return;
    }

    loadMoreButton.dataset.blogInitialized = 'true';
    const sectionId = loadMoreButton.getAttribute('data-section-id') || 'blog';

    loadMoreButton.addEventListener('click', async (event) => {
        event.preventDefault();

        const url = loadMoreButton.getAttribute('data-blog-load-more');
        if (!url) {
            return;
        }

        loadMoreButton.disabled = true;
        blogPostsContainer.setAttribute('aria-busy', 'true');

        try {
            const response = await fetch(`${url}&section_id=${sectionId}`);
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const newPosts = html.querySelector('[data-blog-posts]');
            const firstNewIndex = blogPostsContainer.children.length;

            if (newPosts) {
                blogPostsContainer.append(...newPosts.children);
            }

            const _loadMoreButton = html.querySelector('[data-blog-load-more]');
            if (_loadMoreButton?.hasAttribute('data-blog-load-more')) {
                loadMoreButton.setAttribute('data-blog-load-more', _loadMoreButton.getAttribute('data-blog-load-more') ?? '');
                loadMoreButton.disabled = false;
            } else {
                loadMoreButton.remove();
            }

            const firstNewItem = blogPostsContainer.children[firstNewIndex];
            const focusTarget = firstNewItem?.matches('a, button')
                ? firstNewItem
                : firstNewItem?.querySelector('a, button');
            if (focusTarget instanceof HTMLElement) {
                focusTarget.focus();
            }
        } catch (error) {
            console.error('Error fetching blog posts:', error);
            loadMoreButton.disabled = false;
        } finally {
            blogPostsContainer.setAttribute('aria-busy', 'false');
        }
    });
};

/** @param {ParentNode} [root] */
const initBlog = (root = document) => {
    root.querySelectorAll('[data-blog-load-more]').forEach((button) => {
        if (button instanceof HTMLButtonElement) {
            initButton(button);
        }
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initBlog());
} else {
    initBlog();
}

document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof HTMLElement) {
        initBlog(event.target);
    }
});
